export const nameToUrl = (name: string) => {
    return name
        .toLowerCase() // Convert to lowercase
        .replace(/[^\p{L}0-9\s-]/gu, '') // Remove unwanted characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Remove consecutive hyphens
        .trim(); // Trim leading/trailing spaces
}

const URL_ID_LENGTH = 36;

export const dataFromUrlName = (dataUrl: string) => {
    return dataUrl.slice(-URL_ID_LENGTH);
}

export const nameFromUrlName = (dataUrl: string) => {
    const namePart = dataUrl.slice(0, -URL_ID_LENGTH);
    return namePart.endsWith('-') ? namePart.slice(0, -1) : namePart;
}
